const standardPrefix = '/pipeline';
const edgePrefix = '/pipeline/edge';

export const standardRoute = {
  draftSource: (draftSourceId: number | string): string => `${standardPrefix}/draft-source/${draftSourceId}`,
  overview: (seqId: number | string): string => `${standardPrefix}/${seqId}/overview`,
};

export const edgeRoute = {
  overview: (integrationId: number | string): string => `${edgePrefix}/${integrationId}/`,
  jobHistory: (integrationId: number | string): string => `${edgePrefix}/${integrationId}/job-history`,
  create: (integrationId: number | string, sourceType?: string): string =>
    sourceType
      ? `${edgePrefix}/${integrationId}/create?source_type=${sourceType}`
      : `${edgePrefix}/${integrationId}/create`,
};
